import {
  SwipeableProgressBar,
  SwipeableProvider,
  SwipeableSlider,
} from '@jouzen/ecom-components/v3/SwipeableSlider';
import type { MouseEvent } from 'react';

import ArticleCard, {
  type ArticleCardDataProps,
} from '@/app/components/ArticleCardsModule/ArticleCard';
import SwipeableNavButtons from '@/app/components/SwipeableNavButtons';

const ArticleCardsMobile = ({
  articleCards,
  onClick,
}: {
  readonly articleCards: ArticleCardDataProps[];
  readonly onClick: (event: MouseEvent<HTMLAnchorElement>) => void;
}) => {
  return (
    <div className="lg:hidden">
      <SwipeableProvider>
        <div className="flex flex-col-reverse">
          <div className="relative mt-6 mr-6">
            <SwipeableProgressBar variant="light" />
            <SwipeableNavButtons />
          </div>
          <SwipeableSlider className="pr-6">
            {articleCards.map(({ heading, ...props }) => {
              return (
                <ArticleCard
                  key={heading}
                  heading={heading}
                  {...props}
                  onClick={onClick}
                />
              );
            })}
          </SwipeableSlider>
        </div>
      </SwipeableProvider>
    </div>
  );
};

export default ArticleCardsMobile;
